<div class="row" [formGroup]="form">
  <label for="bankName">Bank</label>
  <div class="selectWrapper">
    <select formControlName="bankName" id="bankName">
      <option
        *ngFor="let option of bankOptions"
        [value]="option.value"
        [disabled]="option.disabled"
      >
        {{ option.label }}
      </option>
    </select>
    <svg-icon
      src="/resultpage/assets/icons/Chevron_Arrow.svg"
      [ngClass]="['arrowIcon']"
      [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
    ></svg-icon>
  </div>
</div>
